<template>
    <div>
    <div class="select-box select-box-double" >
        <div class="select-box-current" v-ripple @click="toggleSelectBox">
            <span>FROM: {{selectedFromValue}}</span>
            <i class="fa" :class="{ 'fa-chevron-down': !open, 'fa-chevron-up': open }"></i>
        </div>
        <div class="select-box-open" :class="{ open }">
            <div class="select-box-separator"></div>
            <div class="select-box-items">
                <div class="select-box-item" v-for="item in invertedItemsFrom" :key="item.value[1]" @click="selectFromItem(item)"  v-ripple>
                    <i class="fa fa-check" :class="{ visible: selectedFromValue === (item.value[0] + ', ' + item.value[1]) }"></i>
                    <span>{{ item.text }}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="select-box">
        <div class="select-box-current" v-ripple @click="toggleSelectBox">
            <span>TO: {{selectedToValue}} </span>
            <i class="fa" :class="{ 'fa-chevron-down': !open, 'fa-chevron-up': open }"></i>
        </div>
        <div class="select-box-open" :class="{ open }">
            <div class="select-box-separator"></div>
            <div class="select-box-items">
                <div class="select-box-item" v-for="item in invertedItemsTo" :key="item.value[1]" @click="selectToItem(item)" v-ripple>
                    <i class="fa fa-check" :class="{ visible: selectedToValue === (item.value[0] + ', ' + item.value[1]) }"></i>
                    <span>{{ item.text }}</span>
                </div>
            </div>
        </div>

    </div>

    </div>
</template>

<script>

export default {
    props: {
        items: null,
        selectedItems: null,
        value: {
            type: String,
        },

    },
    data() {
        return {
            selectedFromValue: [],
            selectedToValue: [],
            open: false,
            invertedItemsFrom: [],
            invertedItemsTo: [],
            quarters: [],
        };
    },
    created() {
        if (this.items === undefined) {
            this.invertedItemsFrom = [];
            this.invertedItemsTo = [];
        } else {
            const itemArray = this.items.split(',').reverse();
            for (let i = 1; i < 5; i++) {
                const itemValueTo = [itemArray[0], "Q" + i ];
                const itemValueFrom = [itemArray[1], "Q" + i ]
                const itemObjectTo = { text: itemArray[0] + " Q" + i, value: itemValueTo };
                const itemObjectFrom = { text: itemArray[1] + " Q" + i, value: itemValueFrom };
                this.invertedItemsFrom.push(itemObjectFrom);
                this.invertedItemsTo.push(itemObjectTo);
            }
            this.setDefaultSelectedValue(itemArray);
        }
    },
    methods: {
        toggleSelectBox() {
            this.open = !this.open;
        },
        setDefaultSelectedValue(itemArray) {
            if (this.selectedItems !== undefined && this.selectedItems !== '') {
                const selectedItemsArray = this.selectedItems.split('-');
                const itemArray1 = selectedItemsArray[0].split(',');
                const itemArray2 = selectedItemsArray[1].split(',');
                if (itemArray[0] === itemArray2[0] && itemArray1[0] === itemArray[1]) {
                    this.selectedFromValue = itemArray1[0] + ", " + itemArray1[1];
                    this.selectedToValue = itemArray2[0] + ", " + itemArray2[1];
                } else {
                    this.setDefaultQuarters();
                }
            } else {
                this.setDefaultQuarters();
            }
        },
        setDefaultQuarters() {
            this.selectedFromValue = this.invertedItemsFrom[0].value[0] + ", " + this.invertedItemsFrom[0].value[1];
            this.selectedToValue = this.invertedItemsTo[3].value[0] + ", " + this.invertedItemsTo[3].value[1];
        },
        selectFromItem(item) {
            this.selectedFromValue = item.value[0] + ", " + item.value[1];
            this.open = false;
            this.$emit('input', this.selectedFromValue.split(' ').join('') + '-' + this.selectedToValue.split(' ').join(''));
        },
        selectToItem(item) {
            this.selectedToValue = item.value[0] + ", " + item.value[1];
            this.open = false;
            this.$emit('input', this.selectedFromValue.split(' ').join('') + '-' + this.selectedToValue.split(' ').join(''));
        },
    },
};

</script>

<style lang="scss">
    @import '../../style/common/SelectBox.scss';
</style>
